import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../app.config';
@Injectable()
export class RefreshTokenService {
  sessionStorageTokenName: string = 'jwt-token';
  sessionStorageRefreshTokenName: string = 'jwt-refresh-token';
  sessionStorageTokenExpirationDate: string = 'expiration-date';

  constructor(private _http: HttpClient, private _appConfig: AppConfig) {
  }

  getRefreshToken() {
    return sessionStorage.getItem(this.sessionStorageRefreshTokenName);
  }

  refreshToken(token) {
    return this._http.post(this.getRefreshTokenUrl(), { token: token });
  }

  saveJWTToken(token, expirationDate) {
    sessionStorage.setItem(this.sessionStorageTokenName, token);
    sessionStorage.setItem(this.sessionStorageTokenExpirationDate, expirationDate);
  }

  private getRefreshTokenUrl() {
    return this._appConfig.getConfig().nPointAuthService + '/auth/refreshtoken';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/refresh.service.ts